import { render } from "./AccountPaypalMembership.vue?vue&type=template&id=48fe7402"
import script from "./AccountPaypalMembership.vue?vue&type=script&lang=js"
export * from "./AccountPaypalMembership.vue?vue&type=script&lang=js"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__